import { lazy } from 'react';
import { useLoadAdminDependencies } from 'ProtectedRoute/useLoadAdminDependencies';

// Lazy, so the users list loads only when an admin opens the page, as it did inside the admin bundle.
const AdminUsers = lazy(() => import(/* webpackPrefetch: true */ 'AdminUsers'));

export function AdminUsersComponent() {
    // The list reads Angular services, such as User and LogInAs, that the admin bundle registers.
    useLoadAdminDependencies();
    return <AdminUsers />;
}
